import React from 'react'
import { ContentContainer, services, View } from '../common'

class Privacy extends React.Component {
  componentDidMount() {
    services.createDocsieScript({
      dataDocsie: 'live_pk_qk4FN4wGs1eUiPJ6Wty0WJdq:boo_jcL1B5dso02RE627F',
    })()
  }

  render() {
    return (
      <View>
        <ContentContainer>
          <div data-ddsroot />
        </ContentContainer>
      </View>
    )
  }
}

export { Privacy }
export default Privacy



// WEBPACK FOOTER //
// ./src/modules/pages/Translation.js